export const VISIT_HISTORY_OPTIONS = [
  { value: "never_booked", label: "Never booked" },
  { value: "booked_never_came", label: "Booked, never came" },
  { value: "visited_not_paid", label: "Visited, didn't pay" },
  { value: "visited_paid", label: "Visited and paid" },
];
